import { render } from "./NotificationListItem.vue?vue&type=template&id=3d6da4e9&scoped=true&ts=true"
import script from "./NotificationListItem.vue?vue&type=script&lang=ts"
export * from "./NotificationListItem.vue?vue&type=script&lang=ts"

import "./NotificationListItem.vue?vue&type=style&index=0&id=3d6da4e9&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6da4e9"]])

export default __exports__